import { useState } from "react";
import HeaderComponent from "../../components/header";
import BannerComponent from "../../components/banner";
import FooterComponent from "../../components/footer";
import backdrop from "../../assets/images/backdrop.png";

function Home() {
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  return (
    <div
      className=""
      style={{
        backgroundImage: `url(${backdrop})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="relative">
        <HeaderComponent openMenu={openMenu} setOpenMenu={setOpenMenu} />
        <BannerComponent />
      </div>
      <FooterComponent />
    </div>
  );
}

export default Home;
